import * as React from 'react';
import {InlineLabeledRadio} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';
import Constants from '../../globals/Constants';
import HelpLink from '../HelpLink/HelpLink';

export default ({isLinkSelected, onChange, themeName, isDisabled}: ShareReviewPrivacyProps) => {
   const shareReviewStrings = Strings.labels.shareReviewPrivacy;

   const onLinkSelected = (): void => {
      onChange(true);
   };

   const onInviteSelected = (): void => {
      onChange(false);
   };

   return (
      <div className="share-review-privacy-container share-review-section">
         <div className="share-review-privacy-title">
            {shareReviewStrings.title}
            <HelpLink href={Constants.siteLinks.help.access} />
         </div>
         <div onClick={onInviteSelected}>
            <InlineLabeledRadio
               themeName={themeName}
               label={shareReviewStrings.reviewersLabel}
               onChange={onInviteSelected}
               isSelected={!isLinkSelected}
               disabled={isDisabled}
               testId="share-review-invite"
               marginBottom=".5rem"/>
         </div>
         <div onClick={onLinkSelected}>
            <InlineLabeledRadio
               themeName={themeName}
               label={shareReviewStrings.linkLabel}
               onChange={onLinkSelected}
               isSelected={isLinkSelected}
               disabled={isDisabled}
               testId="share-review-link"
               marginBottom="0"/>
         </div>
      </div>
   );
};

export interface ShareReviewPrivacyProps extends Themeable {
   isLinkSelected: boolean;
   isDisabled: boolean;
   onChange(linkSelected: boolean): void;
}
